import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { Place } from './place';
import { PayAccountView, PayAccountViewProxy } from '../views/payaccount';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { PlaceType } from '../types';
import { ClientType } from '../types';

const _schema = {
    "name": "PAYACCOUNT",
    "fields": [
        { name: "place", type: "objid" },
        { name: "status", type: "string", default: "AC" },
        { name: "name", type: "string" },
        { name: "client", type: "objid" },
    ],
    relate: [
        { direction: ">", target: "PLACE", by: "place", name: "place", reason: "place", child: false, class: PlaceType },
        { direction: ">", target: "INVOICEBUSINESS", by: "client", name: "client", reason: "client", child: false, class: ClientType },
        { direction: "<", target: "ACCOUNTINVOICE", by: "account", name: "invoice", reason: "invoices", child: true },
    ]
} as const;

const _PayAccountClass = CreateObject(_schema);
if (!_PayAccountClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class PayAccount extends _PayAccountClass {
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): PayAccount {
        return this._Copy(store) as PayAccount;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'place' && related instanceof Place){
            if (related === this.place){
                related.AddAccount(this);
            }
        }
    }

    override get viewProxy(): PayAccountView {
        return PayAccountViewProxy(this, this.data);
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/

    get status(): string | null {
        return this['__base__status']
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.place){
            if ((this.status == 'DE') && !this.Commited){
                this.place.DelAccount(this);
            }
            else {
                this.place.DoRefresh(this.table);
            }
        }
    }

    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get business(): string | null {
        return this.client?.name ?? null;
    }

    get taxid(): string | null {
        return this.client?.taxid ?? null;
    }

    get address(): string | null {
        return this.client?.address ?? null;
    }

    get IsValid(): boolean {
        if (!this.status){
            return false;
        }

        return (this.status != 'DE');
    }

    get IsBlocked(): boolean {
        return (this.status == 'BL');
    }
}
